import { actAsApi } from "core/api";
import { clearActAsSession, getActAsSession } from "core/act-as/act-as.session";

// Riallineamento con il server. La copia in sessionStorage puo' mentire: la delega puo'
// essere stata chiusa da un'altra scheda, essere scaduta mentre la pagina era chiusa, o
// appartenere a un backend riavviato. Un banner che dice "stai operando per conto di X"
// mentre la delega non esiste piu' e' esattamente il guasto che questa feature deve evitare.
//
// Chiamata solo quando una sessione locale esiste: GET /legals/act-as e' @legal_auth e un
// cliente ci prenderebbe 401, che l'interceptor traduce in logout.
export const syncActAsSession = async (): Promise<void> => {
  const active = getActAsSession();
  if (!active) return;
  try {
    const sessions = await actAsApi.getOpenSessions();
    const stillOpen = sessions.some(
      (session) => session.sessionId === active.sessionId
    );
    if (!stillOpen) clearActAsSession();
  } catch (error) {
    // Rete o backend giu': non si tocca la sessione locale, il server resta comunque
    // l'unico a decidere se l'header vale.
    console.error(error);
  }
};
